import { render, staticRenderFns } from "./Jurisdiction.vue?vue&type=template&id=d06dcad0&scoped=true"
import script from "./Jurisdiction.vue?vue&type=script&lang=js"
export * from "./Jurisdiction.vue?vue&type=script&lang=js"
import style0 from "./Jurisdiction.vue?vue&type=style&index=0&id=d06dcad0&prod&lang=css"
import style1 from "./Jurisdiction.vue?vue&type=style&index=1&id=d06dcad0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d06dcad0",
  null
  
)

export default component.exports